import { useState } from "react";
import IconCustomer from "../SvgIcon/IconCustomer";
import IconCalendar from "../SvgIcon/IconCalendar";
import IconTime from "../SvgIcon/IconTime";
import CustomerDetailsModal from "../ModalDialog/CustomerDetailsModal";
import api from "../../services";
import IconLocation from "../SvgIcon/IconLocation";
import { formatDateOnly } from "../../utils/formats";

export default function CustomerCard({
  user,
  userData = [],
  onClose,
  onSelectLocation,
}) {
  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [loading, setLoading] = useState(false);
  const [activeId, setActiveId] = useState(null); // ✅ local active state

  const handleItemClick = async (item, uniqueId) => {
    setActiveId(uniqueId); // ✅ set active on click
    onSelectLocation?.(item);
    setShowModal(true);
    setSelectedItem(null);

    try {
      setLoading(true);
      const visitId = item.id || item.Id;
      if (visitId) {
        const res = await api.get(`visit/${visitId}`);
        const data = Array.isArray(res.data) ? res.data[0] : res.data;
        setSelectedItem(data);
      } else {
        setSelectedItem(item);
      }
    } catch (error) {
      console.error("Error fetching visit details:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="customer-card">
      <div className="d-flex justify-content-between align-items-center py-2 px-3 border-bottom">
        <h3>{user?.UserName}</h3>
        <div className="d-flex gap-3 align-items-center">
          <p className="m-0 total-visits">Total Visits: {userData.length}</p>
          <button className="closebutton" onClick={() => onClose?.()}>✕</button>
        </div>
      </div>

      <div className="visit-list">
        {userData.map((item, index) => {
          const uniqueId = String(item.id || `${item.type}-${index}`);
          const dateValue = item.captured_Date;
          const isScheduled = item.type === "SCHEDULED";

          return (
            <div
              key={uniqueId}
              className={`list-details ${isScheduled ? "scheduled-card" : "visit-card"} ${activeId === uniqueId ? "active" : ""}`}
              onClick={() => handleItemClick(item, uniqueId)}
            >
              <div className="custor-name">
                <IconCustomer /> {item.CustomerName || "-"}
                {isScheduled && (
                  <span className="type-badge badge-scheduled">Scheduled</span>
                )}
              </div>
              <p>
                <IconCalendar />{" "}
                {dateValue ? formatDateOnly(dateValue) : "-"}
              </p>
              <p>
                <IconTime />{" "}
                {dateValue ? new Date(dateValue).toLocaleTimeString() : "--"}
              </p>
              {item.Address && (
                <p><IconLocation width="14" height="14" /> {item.Address} - {item.CurrentLocation}</p>
              )}
              <span className="squence">{index + 1}</span>
            </div>
          );
        })}
      </div>

      <CustomerDetailsModal
        show={showModal}
        loading={loading}
        customer={selectedItem}
        onClose={() => setShowModal(false)}
      />
    </div>
  );
}